/*
 * @Author: hzk
 * @Date: 2021-01-18 16:15:11
 * @LastEditors: hzk
 * @LastEditTime: 2021-01-18 16:15:31
 */
import RealName from './real-name.vue';

export default RealName;